import { render, staticRenderFns } from "./GdashMap.vue?vue&type=template&id=60b7b61f"
import script from "./GdashMap.vue?vue&type=script&lang=js"
export * from "./GdashMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports